{
  "version": 1,
  "asset_id": "f68df93a-6af7-49f4-bb82-cac31fdfca2e",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/f68df93a-6af7-49f4-bb82-cac31fdfca2e/loc-round-rock-1280.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/f68df93a-6af7-49f4-bb82-cac31fdfca2e/loc-round-rock-1280.avif",
  "original_filename": "loc-round-rock-1280.avif",
  "size": 91071,
  "content_type": "image/avif",
  "created_at": "2026-07-25T02:26:31Z"
}
